import React from "react";
import PropTypes from "prop-types";

const shapes = { round: "rounded-lg" };
const variants = {
  outline: { blue_A700: "border border-blue-A700 border-solid text-blue-A700" },
  fill: {
    blue_50: "bg-blue-50 text-blue-A700",
    gray_100_04: "bg-gray-100_04 text-black-900",
    blue_A700: "bg-blue-A700 text-white-A700",
    white: "white",
  },
};
const sizes = { xs: "p-[7px]", sm: "p-[11px]", md: "p-3.5", lg: "p-[18px]" };

const Button = ({
  children,
  className = "",
  leftIcon,
  rightIcon,
  shape = "",
  size = "",
  variant = "",
  color = "",
  type = "button",
  disabled = false, // added
  ...restProps
}) => {
  return (
    <button
      className={`${className} ${(shape && shapes[shape]) || ""} ${
        (size && sizes[size]) || ""
      } ${(variant && variants[variant]?.[color]) || ""}`}
      {...restProps}
    >
      {!!leftIcon && leftIcon}
      {children}
      {!!rightIcon && rightIcon}
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  shape: PropTypes.oneOf(["round"]),
  size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
  variant: PropTypes.oneOf(["outline", "fill"]),
  color: PropTypes.oneOf(["blue_A700", "blue_50", "gray_100_04"]),
  type: PropTypes.oneOf(["button", "submit"]),
};

export { Button };
